export function illegalDump(value) {
	if (value === 0) return 'Nee';
	if (value === 1) return 'Ja, minder dan de helft';
	if (value === 2) return 'Ja, meer dan de helft';
	if (value < 0) return 'Niet gemeten';
}

export default { illegalDump };
